import { CHAT, ESTABLISHMENTS } from 'navigation/CONSTANTS'
import React from 'react'
import { useLocation } from 'react-router-dom'

/**
 * EstablishmentManagerVisible component
 * This component checks the current location and conditionally renders its children.
 * If the current path starts with either CHAT or ESTABLISHMENTS, it renders nothing.
 * Otherwise, it renders its children.
 * @param {React.PropsWithChildren} props - The properties for the EstablishmentManagerVisible component.
 * @returns {JSX.Element} The rendered children or an empty fragment.
 * @example
 * <EstablishmentManagerVisible>
 *   <SomeComponent />
 * </EstablishmentManagerVisible>
 */
export const EstablishmentManagerVisible: React.FC<
  React.PropsWithChildren
> = props => {
  const location = useLocation()
  const routes = [CHAT, ESTABLISHMENTS]

  if (routes.find(route => location.pathname.startsWith(`/${route}`))) {
    return <></>
  }

  return <>{props.children}</>
}
